import { forwardRef, type AnchorHTMLAttributes } from 'react'
import { Link } from 'react-router'

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href: string
}

/**
 * `<HrefLink>` — react-router's <Link> with a `next/link`-compatible API.
 *
 * @rr/ui components like `SecondaryTabBar` and `TopNav` accept an `as` prop
 * that receives an `href` (the next/link convention). React Router's Link
 * uses `to` instead, so we adapt here in one place rather than touching
 * every consumer in @rr/ui.
 */
export const HrefLink = forwardRef<HTMLAnchorElement, Props>(
  function HrefLink({ href, children, ...rest }, ref) {
    return (
      <Link ref={ref} to={href} {...rest}>
        {children}
      </Link>
    )
  },
)
